import { isFirstEdit } from "./edit-recipe";
import type { EditRecipe } from "./edit-recipe.schema";

/**
 * Corps métier envoyé au converter (`POST /uploadV3/retouch`).
 * Les champs d'infra (S3_BUCKET, provider, API_URL, instanceId) sont ajoutés
 * par le client BO `retouchImage` — ils ne font pas partie de ce module.
 */
export type RetouchRequest = {
  attachmentId: string;
  /** Clé S3 de base (`Attachment.link`), inchangée par la retouche. */
  link: string;
  isHd: boolean;
  /** True ssi `Attachment.editRecipe` est encore null. */
  isFirstEdit: boolean;
  recipe: EditRecipe;
  applyWatermark?: boolean;
};

export function buildRetouchRequest(args: {
  attachmentId: string;
  link: string;
  isHd?: boolean;
  /** Recette actuellement persistée (pas le brouillon UI). */
  savedRecipe?: unknown;
  recipe: EditRecipe;
  applyWatermark?: boolean;
}): RetouchRequest {
  return {
    attachmentId: args.attachmentId,
    link: args.link,
    isHd: args.isHd === true,
    isFirstEdit: isFirstEdit(args.savedRecipe),
    recipe: args.recipe,
    applyWatermark: args.applyWatermark,
  };
}
